import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Loading from '../components/Loading';
import SingleJob from '../components/SingleJob';
import { filtering, searching } from '../features/jobs/filterSlice';
import { getAllJobs } from '../features/jobs/jobSlice';

const Home = () => {

  const { pathname } = useLocation();
  const [showTitle, setShowTitle] = useState('')

  const { allJobs, isLoading, isError
    , error } = useSelector(state => state.jobs)
  const { filter, search } = useSelector(state => state.filter);



  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getAllJobs())
  }, [])


  useEffect(() => {
    setShowTitle(pathname?.split("/")[2])
  }, [pathname])


  const [filterJobs, setfilterJobs] = useState([])
  useEffect(() => {
    setfilterJobs([...filterFunc()])
  }, [filter, search, allJobs]);


  const filterFunc = () => {

    let filterResponse = [...allJobs]
   
      if (filter == 'Salary (High to Low)') {
       
        filterResponse = filterResponse?.sort((a, b) => (b?.salary - a?.salary))

      }
    if (filter == 'Salary (Low to High)') {

      filterResponse = filterResponse?.sort((a, b) =>(a.salary - b.salary))

      }

    
    if (search) {

      filterResponse = filterResponse.filter(job => (job.title.toLowerCase().includes(search.toLowerCase())))

    }

    return filterResponse
  }

  let content = ''

  if (isLoading) content = <Loading />;
  if (!isLoading && isError)
    content = <div className="col-span-12">{error}</div>;

  if (!isError && !isLoading && filterJobs?.length === 0) {
    content = <div className="col-span-12">No Jobs found!</div>;
  }

  if (!isError && !isLoading && filterJobs?.length > 0) {

    if (showTitle) {

      if (showTitle == 'Fulltime') {
        content = filterJobs?.filter(j => (j.type == 'Full Time')).map((job) => (
          <SingleJob key={job.id} job={job} />
        ));
      } else {
        content = filterJobs?.filter(j => (j.type == showTitle)).map((job) => (
          <SingleJob key={job.id} job={job} />
        ));
      }


    } else {

      content = filterJobs?.map((job) => (
        <SingleJob key={job.id} job={job} />
      ));
    }

  }




  const filterOptions = [

    { id: 1, name: "Default" },
    { id: 2, value: 'Salary (Low to High)', name: "Salary (Low to High)" },
    { id: 3, value: 'Salary (High to Low)', name: "Salary (High to Low)" },

  ]
  return (
    <>


      <div className="lg:pl-[14rem]  mt-[5.8125rem]">
        <main className="max-w-3xl rounded-lg  mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
          <div className="md:flex space-y-2 md:space-y-0 justify-between mb-10 ">
            <h1 className="lws-section-title">{!showTitle && "All"} Available {showTitle && showTitle} Jobs</h1>
            <div className="flex gap-4">
              <div className="search-field group flex-1">
                <i className="fa-solid fa-magnifying-glass search-icon group-focus-within:text-blue-500" />
                <input onChange={(e) => dispatch(searching(e.target.value)
                )} type="text" placeholder="Search Job" className="search-input" id="lws-searchJob" />
              </div>
              <select onChange={(e) => dispatch(filtering(e.target.value)
              )} id="lws-sort" name="sort" autoComplete="sort" className="flex-1">
                {filterOptions.map(op => (

                  <option key={op.id}   {...op} >{op.name}</option>
                ))}

              </select>
            </div>
          </div>
          <div className="jobs-list">
            {/* Single Job 1*/}
            {content}
            {/* Single Job 1*/}
          </div>
        </main>
      </div>

    </>
  )
}

export default Home